// @ts-nocheck

import { createSlice, createAsyncThunk, PayloadAction } from "@reduxjs/toolkit";
import { fetchAboutUs, addAboutUs, updateAboutUs } from "../../api/aboutusSection";


export const getAboutUs = createAsyncThunk(
  "aboutUs/getAboutUs",
  async (_, { dispatch, rejectWithValue }) => {
    dispatch(resetStatus());

    try {
      return await fetchAboutUs();
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

export const createAboutUs = createAsyncThunk(
  "aboutUs/createAboutUs",
  async (newAboutUs: { title: string; description: string; is_active: boolean; image?: string }, { dispatch, rejectWithValue }) => {
    dispatch(resetStatus());

    try {
      return await addAboutUs(newAboutUs);
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

export const editAboutUs = createAsyncThunk(
  "aboutUs/editAboutUs",
  async (
    { updatedAboutUs }: { updatedAboutUs: { title: string; description: string; is_active: boolean; image?: string } },
    { dispatch, rejectWithValue }
  ) => {
    dispatch(resetStatus());

    try {
      return await updateAboutUs(updatedAboutUs);
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

// About Us Slice

const aboutUsSlice = createSlice({
  name: "aboutUs",
  initialState: {
    aboutUs: {} as any,
    status: null as boolean | null,
    msg: "",
    error: null as string | null,
  },
  reducers: {
    resetStatus(state) {
      state.status = null;
      state.msg = "";
    },
  },
  extraReducers: (builder) => {
    builder
      // Get About Us
      .addCase(getAboutUs.fulfilled, (state, action: PayloadAction<any>) => {
        state.status = true;
        state.aboutUs = action.payload;
      })
      .addCase(getAboutUs.rejected, (state, action) => {
        state.status = false;
        state.error = action.payload as string;
      })

      // Create About Us
      .addCase(createAboutUs.fulfilled, (state, action: PayloadAction<any>) => {
        state.aboutUs = action.payload;
        state.status = true;
        state.msg = "About Us created successfully.";
      })
      .addCase(createAboutUs.rejected, (state, action) => {
        state.status = false;
        state.error = action.payload as string;
      })

      // Edit About Us
      .addCase(editAboutUs.fulfilled, (state, action: PayloadAction<any>) => {
        state.aboutUs = action.payload;
        state.status = true;
        state.msg = "About Us updated successfully.";
      })
      .addCase(editAboutUs.rejected, (state, action) => {
        state.status = false;
        state.error = action.payload as string;
      });
  },
});

export const { resetStatus } = aboutUsSlice.actions;
export default aboutUsSlice.reducer;
